export default __webpack_public_path__ + "static/media/google-play-hover.4d4236a3.png";